import { useState } from "react";
import { Badge, Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import print from "../../../Enums/Print";
import Pagination from "../Pagination/Pagination";
import { ExportExcel } from "../../../Enums/Export";
import ReportsService from "../../../../services/ReportsService";
import Select from "react-select";

const BookingReports = () => {
	const [data, setData] = useState([]);
	const [status, setStatus] = useState("");
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const reportsService = new ReportsService();
	const search = useSelector((state) => state.auth.search);
	const options = [
		{ label: Translate[lang].confirmed, value: "confirmed" },
		{ label: Translate[lang].closed, value: "closed" },
	];

	const printPage = () => {
		let headRow = [
			"ID",
			Translate[lang].court_name,
			Translate[lang].date,
			Translate[lang].time,
			Translate[lang].user,
			Translate[lang].phone,
			Translate[lang].status,
		];
		let dataInfo = data?.map((res) => {
			let info = {
				id: res?.id,
				court_name: res?.court_name,
				date: res?.date?.split("T")[0],
				time: res.time,
				user_fullname: res?.user_fullname,
				user_phone: res?.user_phone,
				status: res?.booking_status,
			};
			return info;
		});
		print("Users", headRow, lang, dataInfo);
	};

	return (
		<>
			<div className="d-flex justify-content-between mb-4 align-items-center">
				<span
					style={{
						fontWeight: "600",
						textTransform: "capitalize",
						color: "#000",
					}}>
					{Translate[lang].booking_reports}
				</span>
				<div className="d-flex gap-8">
					<Button
						variant="outline-primary"
						onClick={() => ExportExcel(data, "booking-reports")}>
						<i className="las la-download fs-20" /> {Translate[lang].export}
					</Button>
					<Button variant="primary" onClick={() => printPage()}>
						<i className="las la-print fs-20" /> {Translate[lang].print}
					</Button>
				</div>
			</div>
			<div class="accordion " id="accordionExample">
				<div class="accordion-item border-shadow p-0">
					<h2 class="accordion-header" id="headingOne">
						<button
							class="accordion-button fw-bold"
							type="button"
							style={{
								fontSize: "18px",
								background: "none",
								boxShadow: "none",
								color: "#000",
							}}
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne">
							{Translate[lang].filter}
						</button>
					</h2>
					<div
						id="collapseOne"
						class="accordion-collapse collapse show"
						aria-labelledby="headingOne"
						data-bs-parent="#accordionExample">
						<div class="accordion-body px-0">
							<div className="row w-100 m-auto">
								<div className="col-4">
									<label>{Translate[lang].status}</label>
									<Select
										options={options}
										value={status}
										onChange={(e) => setStatus(e)}
									/>
								</div>
								<div className={!!status ? "col-4" : "col-2"}>
									<div className="d-flex h-100 gap-8 align-items-end">
										<Button
											variant="outline-primary"
											className="w-100"
											onClick={() => setShouldUpdate((prev) => !prev)}>
											{Translate[lang].apply}
										</Button>
										{!!status && (
											<Button
												variant="outline-danger"
												className="w-100"
												onClick={() => {
													setStatus("");
													setShouldUpdate((prev) => !prev);
												}}>
												{Translate[lang].clear_filter}
											</Button>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="mt-4">
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>ID</strong>
									</th>
									<th>
										<strong>{Translate[lang].court_name}</strong>
									</th>
									<th>
										<strong>{Translate[lang].date}</strong>
									</th>
									<th>
										<strong>{Translate[lang].time}</strong>
									</th>
									<th>
										<strong>{Translate[lang].user}</strong>
									</th>
									<th>
										<strong>{Translate[lang].phone}</strong>
									</th>
									<th>
										<strong>{Translate[lang].status}</strong>
									</th>
								</tr>
							</thead>

							<tbody className="table-body">
								{data?.map((item, index) => {
									return (
										<tr key={index} className="text-center">
											<td className="text-wrap-mode">{item.id}</td>
											<td className="text-wrap-mode">{item.court_name}</td>
											<td>{item?.date?.split("T")[0]}</td>
											<td>{item?.time}</td>
											<td>{item?.user_fullname}</td>
											<td>{item?.user_phone}</td>
											<td>
												<Badge
													className="text-capitalize cursor-pointer"
													variant={`${
														item?.booking_status === "pending"
															? "secondary"
															: item?.booking_status === "confirmed"
															? "success"
															: "danger"
													} light`}>
													{Translate[lang][item?.booking_status]}
												</Badge>
											</td>
										</tr>
									);
								})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && !loading && <NoData />}
					<Pagination
						setData={setData}
						service={reportsService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						type="booking"
						param={
							!!status
								? {
										Status: status?.value,
								  }
								: ""
						}
					/>
				</div>
			</div>
		</>
	);
};

export default BookingReports;
